<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Cadastro Agenda - Procedimento</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioDeCadastroProcedimentoAgenda" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-12 col-12" formGroupName="pk">
                            <mat-label>Procedimento</mat-label>
                            <input matInput value="Procedimento" class="form-control" id="idProcedimento" required
                                trim="blur" name="idProcedimento" formControlName="idProcedimento" maxlength="60"
                                upperCase>
                            <mat-error
                                *ngIf="formularioDeCadastroProcedimentoAgenda.controls.pk.get('idProcedimento')?.hasError('required')">
                                O campo Procedimento é obrigatório.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-12 col-12" formGroupName="pk">
                            <mat-label>Filial</mat-label>
                            <mat-select value="Filial" formControlName="idFilial" name="idFilial" id="idFilial"
                                required>
                                <mat-option *ngFor="let filial of listaFiliais" [value]="filial.id">
                                    {{filial.nome}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioDeCadastroProcedimentoAgenda.controls.pk.get('idFilial')?.hasError('required')">
                                O campo Filial é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-6 col-12" formGroupName="pk">
                            <mat-label>Dia</mat-label>
                            <mat-select value="Dia" formControlName="diaSemana" name="diaSemana" id="diaSemana">
                                <mat-option [value]=""></mat-option>
                                <mat-option *ngFor="let diaSemana of listaDiasDaSemana" [value]="diaSemana.codigo">
                                    {{diaSemana.descricao}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="formularioDeCadastroProcedimentoAgenda.controls.pk.get('diaSemana')?.hasError('required')">
                                O campo Dia é obrigatório.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-6 col-12" formGroupName="pk">
                            <mat-label>Horário</mat-label>
                            <mat-select value="Horário" formControlName="horaAtendimento" name="horaAtendimento">
                                <mat-option *ngFor="let horaAtendimento of listaHorarios"
                                    [value]="horaAtendimento.codigo">
                                    {{ horaAtendimento.descricao }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="formularioDeCadastroProcedimentoAgenda.controls.pk.get('horaAtendimento')?.hasError('required')">
                                O campo Horário é obrigatório.
                            </mat-error>
                            <mat-error
                                *ngIf="formularioDeCadastroProcedimentoAgenda.controls.pk.get('horaAtendimento')?.hasError('invalid')">
                                O campo Horário está inválido.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-6 col-12">
                            <mat-label>Idade Min.</mat-label>
                            <input matInput type="number" value="Idade Min." class="form-control" id="atdIdadeMinima"
                                trim="blur" name="atdIdadeMinima" formControlName="atdIdadeMinima" min="0" max="125">
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-6 col-12">
                            <mat-label>Idade Max.</mat-label>
                            <input matInput type="number" value="Idade Max." class="form-control" id="atdIdadeMaxima"
                                trim="blur" name="atdIdadeMaxima" formControlName="atdIdadeMaxima" min="0" max="125">
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Qtd. Atd.</mat-label>
                            <input matInput type="number" value="Qtd. Atd." class="form-control" id="quantidadeAtdGeral"
                                trim="blur" name="quantidadeAtdGeral" formControlName="quantidadeAtdGeral" min="1"
                                max="100">
                            <mat-error
                                *ngIf="formularioDeCadastroProcedimentoAgenda.controls.quantidadeAtdGeral.hasError('required')">
                                O campo Qtd. Atd. é obrigatório.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Início Agenda</mat-label>
                            <input matInput [matDatepicker]="dataInicioAgendaDP" formControlName="dataInicioAgenda"
                                id="dataInicioAgenda" name="dataInicioAgenda">
                            <mat-datepicker-toggle matSuffix [for]="dataInicioAgendaDP"></mat-datepicker-toggle>
                            <mat-datepicker #dataInicioAgendaDP></mat-datepicker>

                            <mat-error
                                *ngIf="formularioDeCadastroProcedimentoAgenda.controls.dataInicioAgenda.hasError('required')">
                                O campo Início Agenda é obrigatório.
                            </mat-error>

                            <mat-error
                                *ngIf="formularioDeCadastroProcedimentoAgenda.controls.dataInicioAgenda.hasError('invalidDate')">
                                O campo Início Agenda está inválido.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>Médico</mat-label>
                            <mat-select value="Médico" formControlName="medico" name="medico" id="medico" required>
                                <mat-option *ngFor="let medico of listaMedicos" [value]="medico">
                                    {{medico.nome}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="formularioDeCadastroProcedimentoAgenda.controls.medico.hasError('required')">
                                O campo Médico é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="card">
                        <div class="card-header" style="font-weight: bold;">Tomadas</div>
                        <div class="card-body" style="padding-bottom: 0px;">
                            <table class="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col" style="text-align: center;">Horário Tomada</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let procedimentoTomada of listaTomadas; let i = index"
                                        (click)="onClickNaTabelaDeTomadas(i)"
                                        [class.active]="i == numeroDaLinhaSelecionadaNaTabelaDeTomadas">
                                        <td style="text-align: center;">{{procedimentoTomada.pk.horaTomada |
                                                horaFormatadaPipe}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12" style="text-align: right;">
                                <button type="button" mat-button color="primary" matTooltip="Novo"
                                    style="margin-right: 20px;" (click)="navegarParaTelaDeCadastroDeTomadas()"
                                    [disabled]="desabilitarCadastroDeTomadas">
                                    Nova Tomada
                                </button>
                                <button type="button" mat-button color="warn" matTooltip="Remover"
                                    style="margin-right: 20px;"
                                    [disabled]="isInfo || numeroDaLinhaSelecionadaNaTabelaDeTomadas == -1"
                                    (click)="removerTomadaSelecionada()">
                                    Remover Tomada
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10" *ngIf="!isInfo">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioDeCadastroProcedimentoAgenda.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="voltarPaginaAnterior()"
                                matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
